<template>
  <v-data-table
    :items="items"
    :loading="loading"
    :headers="headers"
    :hide-default-footer="!detailed"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>
          <v-icon left>mdi-basket-fill</v-icon>
          Coated Materials
        </v-toolbar-title>
        <v-spacer />
        <ShippingItemForm
          v-if="detailed"
          :is-edit="false"
          :batches="batches"
          :loading-batches="loadingBatches"
          :ticketid="parseInt(id)"
        />
      </v-toolbar>
    </template>
    <template v-slot:item.batch.forgeID="{ item }" v-if="detailed">
      <BatchNavigation :instance="item.batch" />
    </template>
    <template v-slot:header.id="{ header }">
      <span v-if="detailed">{{ header.text }}</span>
    </template>
    <template v-slot:item.id="{ item }" v-if="detailed">
      <ShippingItemForm
        :is-edit="true"
        :instance="item"
        :ticketid="parseInt(id)"
        :batches="batches"
        :loading-batches="loadingBatches"
      />
      <ShippingLineItemDelete :instance="item" />
    </template>
  </v-data-table>
</template>

<script>
import ShippingItemForm from "./ShippingItemForm";
import Batch from "../../models/Batch";
import BatchNavigation from "../Batch/BatchNavigation";
import ShippingLineItemDelete from "./ShippingLineItemDelete";
export default {
  name: "ShippingItemTable",
  components: { ShippingLineItemDelete, BatchNavigation, ShippingItemForm },
  props: {
    detailed: {
      required: true,
      type: Boolean,
      default: true
    },
    id: {
      required: true,
      type: Number
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    return {
      loadingBatches: true,
      headers: [
        { text: "Batch", sortable: true, value: "batch.forgeID" },
        { text: "Quantity", sortable: true, value: "quantity" },
        { text: "Notes", sortable: true, value: "notes" },
        { text: "Actions", sortable: false, align: "right", value: "id" }
      ]
    };
  },
  computed: {
    batches() {
      return Batch.query()
        .where("archived", false)
        .get();
    }
  },
  methods: {
    initialize() {
      this.loadingBatches = true;
      Batch
        .$fetchActive()
        .then(() => this.loadingBatches = false)
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>
